export default [
    // 비밀번호 확인
    {
        path: '/pifo/PswdCnfm',
        name: 'PswdCnfm',
        component: () => import('@/views/cmon/pifo/PswdCnfm.vue')
    },
    // 개인정보 관리
    {
        path: '/pifo/PifoMng',
        name: 'PifoMng',
        component: () => import('@/views/cmon/pifo/PifoMng.vue')
    },
    // 비밀번호 관리
    {
        path: '/pifo/PswdSet',
        name: 'PswdSet',
        component: () => import('@/views/cmon/pifo/PswdSet.vue')
    },
    // 비밀번호 변경
    {
        path: '/pifo/PswdChng',
        name: 'PswdChng',
        component: () => import('@/views/cmon/pifo/PswdChng.vue')
    },
    // 점심메뉴 랜덤 뽑기
    {
        path: '/arcade/LunchDraw',
        name: 'LunchDraw',
        component: () => import('@/views/cmon/arcade/LunchDraw.vue')
    },
    // 점심메뉴 관리 - 목록
    {
        path: '/arcade/RestStat',
        name: 'RestStat',
        component: () => import('@/views/cmon/arcade/RestStat.vue')
    },
    // 점심메뉴 관리 - 검색조건
    {
        path: '/arcade/RestSearchCondition',
        name: 'RestSearchCondition',
        component: () => import('@/views/cmon/arcade/RestSearchCondition.vue')
    },
    // 점심메뉴 관리 - 등록 및 수정
    {
        path: '/arcade/RestSave',
        name: 'RestSave',
        component: () => import('@/views/cmon/arcade/RestSave.vue')
    },
    // 점심메뉴 관리 - 상세
    {
        path: '/arcade/RestDetl',
        name: 'RestDetl',
        component: () => import('@/views/cmon/arcade/RestDetl.vue')
    },
]